/**
 * Quiz Content Type
 * A comprehensive assessment with multiple question types
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    quizSchema,
    defaultQuizConfig,
    defaultQuizData,
    type QuizContent,
    type QuizData,
    type QuizItem,
    type QuizSection,
    type QuizConfig,
    type QuizLayoutConfig,
    type QuizScoringConfig,
    type QuizTimerConfig,
    type QuizElementType,
    type ItemLayout,
} from './schema';

// Components
export { QuizPlayer, type QuizPlayerProps, type QuizResults, type QuizItemResult } from './QuizPlayer';
export { QuizEdit, type QuizEditProps } from './QuizEdit';

export { quizContentGrader, gradeQuiz, validateQuizAnswer, countQuizQuestions, quizQuestionCounter } from './scorer';

export { quizValidator } from './validator';

// Default export
export { quizSchema as default } from './schema';

